import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import HomePage from "./pages/HomePage";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import FuturaContour from "./pages/FuturaContour";
import CooliteBoltLaser from "./pages/CooliteBoltLaser";
import LaserHautverjuengung from "./pages/LaserHautverjuengung";
import { CookieBanner } from "./components/CookieBanner";

function App() {
  return (
    <div className="App bg-[#F9F8F6]">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" aria-hidden="true"></div>

      {/* Toast notifications */}
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F9F8F6",
            border: "none",
          },
        }}
      />

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/futura-contour" element={<FuturaContour />} />
          <Route path="/coolite-bolt-laser" element={<CooliteBoltLaser />} />
          <Route path="/laser-hautverjuengung" element={<LaserHautverjuengung />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
